import React from 'react';

export default class StreamingMarkdownErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
